// src/services/dashboardService.js

import API_CONFIG from '../config/apiConfig';
const BASE_URL = API_CONFIG.BASE_URL;

const dashboardService = {
  getPublicStats: async () => {
    try {
      const response = await fetch(`${BASE_URL}/dashboard/stats`, {
        method: 'GET',
        headers: {
          Accept: '*/*',
        },
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();

      return {
        success: true,
        data: {
          registered: data.totalComplaints || 0,
          resolved: data.solvedComplaints || 0,
          pending: data.pendingComplaints || 0,
          inProgress: data.inProgressComplaints || 0,
          acknowledged: data.acknowledgedComplaints || 0,
          rejected: data.rejectedComplaints || 0,
          closed: data.closedComplaints || 0,
        },
      };
    } catch (error) {
      console.error('Error fetching stats:', error);
      return {
        success: false,
        message: error.message,
      };
    }
  },

  getComplaintCountReport: async () => {
    try {
      const response = await fetch(`${BASE_URL}/reports/generate/complaint-count`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }


      const blob = await response.blob();


      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      const title = "Complaint Status Report Gadichiroli";
      const today = new Date();
      const date = `${String(today.getDate()).padStart(2, '0')}-${String(today.getMonth() + 1).padStart(2, '0')}-${today.getFullYear()}`;
      a.download = `${title.replace(/\s+/g, '_')}_${date}.xlsx`;
      document.body.appendChild(a);
      a.click();

      // Cleanup
      a.remove();
      window.URL.revokeObjectURL(url);

      return { success: true };
    } catch (error) {
      console.error('Error fetching complaint count report:', error);
      return { success: false, message: error.message };
    }
  },

  getComplaintAgingReport: async () => {
    try {
      const response = await fetch(`${BASE_URL}/reports/generate/complaint-pending-day`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      const title = "Complaint Aging Report Gadichiroli";
      const today = new Date();
      const date = `${String(today.getDate()).padStart(2, '0')}-${String(today.getMonth() + 1).padStart(2, '0')}-${today.getFullYear()}`;
      a.download = `${title.replace(/\s+/g, '_')}_${date}.xlsx`;
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);
      return { success: true };


    } catch (error) {
      console.error('Error fetching complaint aging report:', error);
      return { success: false, message: error.message };
    }

  }
,

 updatePriority: async (complaintId, priority) => {
    try {
      const response = await fetch(`${BASE_URL}/complaints/${complaintId}/priority`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify({ priority }),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      return { success: true, data };
    } catch (error) {
      console.error('Error updating priority:', error);
      return { success: false, message: error.message };
    }
  },


};
export default dashboardService;
